import {createContext, ReactNode, useContext} from 'react';

/**
 * Opt-in media authoring features for a rich text surface. These gate the editing affordances
 * only; content that already uses them (floated images, uploaded videos) renders everywhere.
 */
export type RichTextMediaFeatures = {
  /** Allow uploading video files (MP4/MOV/WebM) alongside images. */
  videoUploads: boolean;
  /** Show the full-width / wrap-left / wrap-right controls on selected images. */
  imageLayout: boolean;
};

const DEFAULT_FEATURES: RichTextMediaFeatures = {videoUploads: false, imageLayout: false};

const MediaFeaturesContext = createContext<RichTextMediaFeatures>(DEFAULT_FEATURES);

export const MediaFeaturesProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: Partial<RichTextMediaFeatures>;
}) => (
  <MediaFeaturesContext.Provider value={{...DEFAULT_FEATURES, ...value}}>
    {children}
  </MediaFeaturesContext.Provider>
);

export const useRichTextMediaFeatures = () => useContext(MediaFeaturesContext);
